import { reaction } from "mobx";
import { FulfillmentInstructions, } from "../ordering";
import { PurchaseOrderStorageData } from "../ordering/PurchaseOrder/PurchaseOrderStorageData";
import { ApartmentInfoStorageManager } from "./ApartmentInfoStorageManager";
import ConsentsStoreManager from "./ConsentsStorageManager";
import { FulfillmentTimeStorageManager } from "./FulfillmentTimeStorageManager";
import { InvoiceDetailsStorageManager } from "./InvoiceDetailsStorageManager";
import { OnlineContactDetailsStorageManager } from "./OnlineContactDetailsStorageManger";
import { QrWaiterContactDetailsStorageManager } from "./QrWaiterContactDetailsStorageManger";
import { StreetAddressStorageManager } from "./StreetAddressStorageManager";
import { FulfillmentMethodTypeStorageManager } from "./FulfillmentMethodTypeStorageManager";
const CURRENT_STORAGE_VERSION = "1";
export const STORAGE_FORMAT_VERSION_KEY = "client_storageFormatVersion";
export class PurchaseOrderStorageManager {
    constructor(params) {
        this.reactionDisposers = [];
        this.purchaseOrderFactory = params.purchaseOrderFactory;
        this.cartStorageManager = params.cartStorageManager;
        this.fulfillmentTimeStorageManager = new FulfillmentTimeStorageManager();
        this.streetAddressStorageManager = new StreetAddressStorageManager();
        this.apartmentInfoStorageManager = new ApartmentInfoStorageManager({
            country: params.country,
        });
        this.contactDetailsStorageManager = params.isQrWaiterOrder
            ? new QrWaiterContactDetailsStorageManager()
            : new OnlineContactDetailsStorageManager();
        this.invoiceDetailsStorageManager = new InvoiceDetailsStorageManager();
        this.consentsStoreManager = new ConsentsStoreManager();
        this.fulfillmentMethodTypeStorageManager =
            new FulfillmentMethodTypeStorageManager([]);
        this.checkStorageFormatVersion();
    }
    checkStorageFormatVersion() {
        if (localStorage.getItem(STORAGE_FORMAT_VERSION_KEY) !==
            CURRENT_STORAGE_VERSION) {
            this.erase();
            localStorage.setItem(STORAGE_FORMAT_VERSION_KEY, CURRENT_STORAGE_VERSION);
        }
    }
    initialize(storageData) {
        this.reactionDisposers.push(reaction(() => storageData.cartStorageData, (cartStorageData) => this.cartStorageManager.writeCart(cartStorageData)));
        this.reactionDisposers.push(reaction(() => storageData.fulfillmentTimeStorageData, (fulfillmentTimeStorageData) => {
            if (fulfillmentTimeStorageData !== null) {
                this.fulfillmentTimeStorageManager.store(fulfillmentTimeStorageData);
            }
        }));
        this.reactionDisposers.push(reaction(() => storageData.streetAddressStorageData, (streetAddressStorageData) => {
            if (streetAddressStorageData !== null) {
                this.streetAddressStorageManager.store(streetAddressStorageData);
            }
        }));
        this.reactionDisposers.push(reaction(() => storageData.apartmentInfoStorageData, (apartmentInfoStorageData) => {
            if (apartmentInfoStorageData !== null) {
                this.apartmentInfoStorageManager.store(apartmentInfoStorageData);
            }
        }));
        this.reactionDisposers.push(reaction(() => storageData.contactDetailsStorageData, (contactDetailsStorageData) => {
            this.contactDetailsStorageManager.store(contactDetailsStorageData);
        }));
        this.reactionDisposers.push(reaction(() => storageData.invoiceDetailsStorageData, (invoiceDetailsStorageData) => {
            this.invoiceDetailsStorageManager.store(invoiceDetailsStorageData);
        }));
        this.reactionDisposers.push(reaction(() => storageData.consentsStorageData, (consentsStorageData) => {
            this.consentsStoreManager.store(consentsStorageData);
        }));
        this.reactionDisposers.push(reaction(() => storageData.paymentMediumStorageData, (paymentMediumStorageData) => {
            FulfillmentInstructions.persistPaymentMedium(paymentMediumStorageData);
        }));
        this.reactionDisposers.push(reaction(() => storageData.fulfillmentMethodType, (fulfillmentMethodType) => {
            if (fulfillmentMethodType !== null) {
                this.fulfillmentMethodTypeStorageManager.store(fulfillmentMethodType);
            }
        }));
    }
    dispose() {
        this.reactionDisposers.forEach((reactionDisposer) => reactionDisposer());
        this.reactionDisposers = [];
    }
    restoreCart() {
        return this.cartStorageManager.readCart();
    }
    restore(params) {
        const { purchaseOrder, purchaseOrderScope } = this.purchaseOrderFactory.create({
            restaurant: params.restaurant,
            inCartPromotionTypes: params.inCartPromotionTypes,
            cartStorageData: params.cartStorageData,
            contactDetailsLock: params.contactDetailsLock,
            invoiceRequestStorageData: this.invoiceDetailsStorageManager.restore(),
            consentsStorageData: this.consentsStoreManager.restore(),
            contactDetailsStorageData: this.contactDetailsStorageManager.restore(),
            streetAddressStorageData: this.streetAddressStorageManager.restore(),
            apartmentInfoStorageData: this.apartmentInfoStorageManager.restore(),
            fulfillmentTimeStorageData: this.fulfillmentTimeStorageManager.restore(),
        });
        const purchaseOrderStorageData = new PurchaseOrderStorageData({
            purchaseOrder,
            inCartPromotionTypes: params.inCartPromotionTypes,
        });
        this.initialize(purchaseOrderStorageData);
        return { purchaseOrder, purchaseOrderScope };
    }
    erase() {
        this.cartStorageManager.erase();
        this.fulfillmentTimeStorageManager.erase();
        this.streetAddressStorageManager.erase();
        this.apartmentInfoStorageManager.erase();
        this.contactDetailsStorageManager.erase();
        this.invoiceDetailsStorageManager.erase();
        this.consentsStoreManager.erase();
    }
}
